import { Helmet } from 'react-helmet-async';
import { Layout } from '@/components/layout/Layout';
import { useContactData } from '@/hooks/useContactData';
import { useNavigationData } from '@/hooks/useNavigationData';
import { useHomepageData } from '@/hooks/useHomepageData';
import { useSiteData } from '@/hooks/useSiteData';

export function About() {
  const { siteData } = useSiteData();
  const { contactInfo } = useContactData();
  const { navigationItems } = useNavigationData();
  const { pageData } = useHomepageData();

  return (
    <>
      <Helmet>
        <title>About Us - {siteData.title}</title>
        <meta
          name="description"
          content="Learn about the history, mission, and facilities of Wayland Rod and Gun Club. Established in 1930, we promote conservation, education, and outdoor sports."
        />
        <meta name="keywords" content="about, history, mission, Wayland Rod Gun Club, conservation, outdoor sports" />
      </Helmet>

      <Layout contactInfo={contactInfo} navigationItems={navigationItems}>
        <div className="p-4 sm:p-8 space-y-8 sm:space-y-12 max-w-4xl mx-auto">
          <div className="text-center">
            <h1 className="text-4xl sm:text-5xl font-cursive text-primary-700 mb-4">About</h1>
            <p className="text-lg text-neutral-600 leading-relaxed">
              A proud tradition of conservation, education, and outdoor sports since 1930
            </p>
          </div>

          <div className="space-y-4 sm:space-y-6 text-base leading-relaxed font-body max-w-3xl mx-auto">
            <p className="text-neutral-700">{pageData.clubInfo.description}</p>
            <p className="text-neutral-700">{pageData.clubInfo.mission}</p>
            <p className="text-neutral-700">{pageData.clubInfo.facilities}</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="card-professional">
              <h2 className="text-2xl sm:text-3xl font-display font-semibold text-primary-700 mb-4">Our History</h2>
              <div className="space-y-3 text-foreground/90">
                <p>
                  Founded in <strong>1930</strong> and established at our current location in <strong>1940</strong>
                </p>
                <p>
                  Located on <strong>15 acres</strong> in the southwestern corner of Wayland, Massachusetts
                </p>
                <p>Features both indoor and outdoor shooting ranges for various disciplines</p>
              </div>
            </div>

            <div className="card-professional">
              <h2 className="text-2xl sm:text-3xl font-display font-semibold text-primary-700 mb-4">
                Location & Contact
              </h2>
              <div className="space-y-2 text-foreground/90">
                <p>
                  <strong>Address:</strong> {contactInfo.address}
                </p>
                <p>
                  {contactInfo.city}, {contactInfo.state} {contactInfo.zipCode}
                </p>
                <p>
                  <strong>Phone:</strong> {contactInfo.phone}
                </p>
                <p className="pt-2">
                  <a href="/location" className="text-primary hover:text-primary/80 font-medium underline">
                    View detailed directions →
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}